var exports = {
  "kL": "x127c5a35--ca1012--container",
  "Sl": "x127c5a35--ca1012--image",
  "q9": "x127c5a35--ca1012--price",
  "BI": "x127c5a35--ca1012--favorite",
};

module.exports = exports;
